import { put, call, take, fork } from 'redux-saga/effects'
import { courseTranslateService } from '../../api/course'
import { courseTranslateSuccess } from '../../reducers/collection/action'
import { COURSE_TRANSLATE } from '../../reducers/collection/type'
import generalSaga from '../general'
import {
  operationSuccess,
  operationFail,
} from '../../reducers/operation/action'

/**
 *
 * @param {*} payload
 */
function* courseTranslateFlow(payload) {
  try {
    const { code, targetLanguage, callback } = payload

    const response = yield call(courseTranslateService, code, targetLanguage)

    yield put(courseTranslateSuccess(response.data))
    yield put(operationSuccess())

    if (callback) {
      callback(response.data)
    }
  } catch (error) {
    yield put(operationFail(error))
  }
}

/**
 *
 */
export default function* courseTranslateWatcher() {
  while (true) {
    const action = yield take(COURSE_TRANSLATE)
    const { payload } = action

    yield fork(generalSaga, courseTranslateFlow, payload)
  }
}
